import type { DpRequest, DpRequestType } from '../../../../shared/dpRequests';
import type { DpQueueTab } from '../dpRequests.definitions';

export type DpQueueFilterType = 'all' | DpRequestType;

export function classifyDpRequest(request: DpRequest): DpQueueTab {
    if (request.type === 'data_update') {
        if (request.status === 'pending_dp') return 'pending';
        if (request.status === 'pending_correction') return 'waiting';
        return 'closed';
    }

    if (request.type === 'ticket') {
        if (request.status === 'open') return 'pending';
        if (request.status === 'waiting_collaborator') return 'waiting';
        return 'closed';
    }

    if (request.type === 'overtime' || request.type === 'health_plan') {
        return request.status === 'pending_dp' ? 'pending' : 'closed';
    }

    if (request.type === 'raro_invest') {
        return request.status === 'pending_dp' || request.status === 'approved' ? 'pending' : 'closed';
    }

    if (request.status === 'approved') {
        return request.dpRegistration ? 'closed' : 'pending';
    }
    return 'closed';
}

export function matchesDpQueueFilter(request: DpRequest, type: DpQueueFilterType, search: string): boolean {
    if (type !== 'all' && request.type !== type) return false;
    const term = search.trim().toLowerCase();
    if (term === '') return true;
    return (request.collaboratorName ?? '').toLowerCase().includes(term) || request.collaboratorEmail.toLowerCase().includes(term);
}

export function sortByOldestPending(requests: DpRequest[]): DpRequest[] {
    return requests.slice().sort((a, b) => a.statusChangedAt.toDate().getTime() - b.statusChangedAt.toDate().getTime());
}
